export const contentProductDetail = {
	fieldName: {
		image: "Imagem",
		name: "Nome",
		productType: "Tipo do produto",
		unitOfMeasurement: "Estoque controlado por",
		category: "Categoria",
		menuCategory: "Categoria do menu",
		price: "Preço",
		description: "Descrição",
		drinkStyle: "Estilo da bebida",
		alcoholContent: "ABV - Teor alcoólico",
		hasAlcohol: "Contém álcool",
		hiddenZigApp: "Não exibir o produto no ZigApp",
		sincMyTapp: "Sincronizar com MyTapp",
		productReturn: "Produto retornável",
		brand: "Marca",
		variableValue: "Preço variável",
		stockableProduct: "Produto estocável",
		preparationTime: "Tempo de preparo",
		preparationTimePlaceholder: "30",
		preparationTimeUnit: "minutos",
	},
	requiredField: "Campo obrigatório",
	editImage: "Clique na imagem para editar",
	preparationTimeMustBeGreaterThanZero: "O tempo de preparo deve ser maior que 0",
};
